<template>
  <div class="personal_center">
    <div class="personal_center_header">
      <img src="https://download.hecoos.com/enlightv/2025-17/9afd9fdb8b5717b4b118b43b3c449e13.png" alt=""
           @click="goIndex('/en')" />

      <div style="font-size:36px;color:white">

      </div>

      <div class="header_right">
        <button @click="goOrder">MyOrder</button>
        <button @click="logOut">Quit</button>
        <button @click="goIndex('/en')">Home</button>
      </div>
    </div>
    <div style="padding-bottom: 60px;">
      <div class="tableCard">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="Name" min-width="120" align="center">
          </el-table-column>
          <el-table-column  prop="phone"  label="Phone"  width="130"  align="center"  >
          </el-table-column>
          <el-table-column  prop="orderType"  label="Order Type" width="160"  align="center" >
            <template slot-scope="{row}">
              <span v-text="row.type == '1' ? 'Monthly Subscription' : row.type == '2' ? 'Annual Subscription' :'Daily Subscription' "></span>
            </template>
          </el-table-column>
          <el-table-column prop="subject" label="Product" align="center"  min-width="120">
          </el-table-column>
          <el-table-column   prop="time" label="Duration"   width="100" align="center"  ></el-table-column>
          <el-table-column  prop="rec_code" label="Referral Code"  width="120"  align="center" >
          </el-table-column>
          <el-table-column prop="price" label="Price" width="70" align="center">
          </el-table-column>
          <el-table-column   prop="pay_type"   label="Payment Method"  width="140"  align="center" >
          </el-table-column>
          <el-table-column   prop="pay_time"  label="Payment Time"  width="170" align="center" >
          </el-table-column>
          <el-table-column  prop="status_name"  label="Payment Status" width="130"  align="center" >
          </el-table-column>
          <el-table-column prop="operation"   label="Operation"  width="120"  align="center" fixed="right" >
            <template slot-scope="{row}">
              <!-- @click="handleEdit(scope.$index, scope.row)" -->
              <el-button size="small" type="text" v-if="row.is_invoice == 0" @click="issueInvoice(row)">Request Invoice</el-button>
              <span class="font12" v-if="row.is_invoice == 2">Processing</span>
              <span class="font12" v-if="row.is_invoice == 1">Issued</span>
              <!-- Request Invoice -->
              <!-- 开票处理中 Processing
               开票完成 Issued -->
            </template>
          </el-table-column>
        </el-table>

        <div class="table_pagination">
          <el-pagination
              background
              :current-page="pageNum"
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="total">
          </el-pagination>
        </div>

      </div>

      <!-- Modal Dialog -->
      <div
          v-if="showModal"
          class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Apply for Invoice</h3>
            <button class="close-btn" @click="showModal = false">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p data-label="Bill To：">
              <select v-model="invoiceForm.billing_object" name="" id="billing_object"  @change="handleChangeBillingObject">
                <option :value="2">Individual</option>
                <option :value="1">Enterprise</option>
              </select>
            </p>
            <p data-label="Invoice Type：">
              <select v-model="invoiceForm.invoice_type" name="" id="invoice_type">
                <option :value="2">VAT Normal invoice</option>
                <option  v-if="invoiceForm.billing_object != 2" :disabled="invoiceForm.billing_object == 2" :value="1">VAT Special Invoice</option>
              </select>
            </p>

            <template v-if="invoiceForm.billing_object == 2">
              <p data-label="Name：">
                <input type="text" v-model="invoiceForm.name" />
              </p>
            </template>

            <template v-if="invoiceForm.billing_object == 1">
              <p data-label="Company Name：">
                <input type="text" v-model="invoiceForm.company_name" />
              </p>
              <p data-label="Tax ID：">
                <input type="text" v-model="invoiceForm.company_tax_id" />
              </p>
              <p data-label="Company Address：" >
                <input type="text" v-model="invoiceForm.company_address" placeholder="（Optional question）"/>
              </p>
              <p data-label="Phone Number：">
                <input type="text" v-model="invoiceForm.phone_number" placeholder="（Optional question）"/>
              </p>
              <p data-label="Bank Name：" >
                <input type="text" v-model="invoiceForm.bank_name" placeholder="（Optional question）"/>
              </p>
              <p data-label="Bank Account：">
                <input type="text" v-model="invoiceForm.bank_account" placeholder="（Optional question）"/>
              </p>
            </template>

            <p data-label="Email：">
              <input type="text" v-model="invoiceForm.email" />
            </p>
          </div>
          <div class="modal-footer">
            <el-button class="close-btn" @click="showModal = false">Cancel</el-button>
            <button class="confirm-btn" :disabled="btnDisabled" @click="confirmAuthorization">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { Message } from "element-ui"
import { getIndexOrder,invoiceAdd} from "@/api/api";
export default {
  data() {
    return {
      loading:false,
      tableData: [],
      total:0,
      pageNum:1,
      invoiceForm:{
        billing_object:2,
        invoice_type:2,
        company_name:'',
        company_tax_id:'',
        email:'',
        name:'',
        company_address:'',
        phone_number:'',
        bank_name:'',
        bank_account:'',

      },
      invoiceInfo:null,
      showModal: false,
      btnDisabled:false,
    };
  },
  created() {
   this.getOrderList()
  },
  beforeMount() {

  },
  methods: {
    issueInvoice(row) {
      this.invoiceInfo = row
      this.showModal = true;
    },

    handleCurrentChange (val) {
      this.pageNum = val
      this.getOrderList()
    },
    getOrderList(){
      let postData = {
        page:this.pageNum,
        limit:10
      }
      this.loading = true
      getIndexOrder(postData).then(res =>{
        if(res.code == 200){
          let {list,count} = res.data
          this.tableData = list
          this.total = Number(count)
          this.loading = false
        }
      })
    },
    goOrder() {
      this.pageNum = 1
      this.getOrderList()
    },
    goIndex(path) {
      this.$router.push(path);
    },
    logOut() {
      store.commit("clearAdminUserInfo");
      localStorage.clear();
      this.$router.push("/en/login");
    },
    pageTransition(url) {
      this.$router.push({
        path: url
      })
    },
    handleChangeBillingObject(){
      this.$nextTick(()=>{
        if(this.invoiceForm.billing_object == 2){
          this.invoiceForm.invoice_type = 2
        }
      })
    },
    confirmAuthorization() {
      if(this.invoiceForm.billing_object == 1){
        if(!this.invoiceForm.company_name.trim()){
          return this.$message.error('Please enter Company Name')
        }
        if(!this.invoiceForm.company_tax_id.trim()){
          return this.$message.error('Please enter Tax ID')
        }
      }else{
        if(!this.invoiceForm.name.trim()){
          return this.$message.error('Please enter Name')
        }
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.invoiceForm.email) {
        return this.$message.error('Please enter Email')
      } else if (!emailRegex.test(this.invoiceForm.email)) {
        return this.$message.error('Please enter a correct Email')
      }
      let postData = {
        order_id:this.invoiceInfo.id,
        billing_object:this.invoiceForm.billing_object,
        invoice_type:this.invoiceForm.invoice_type,
        email:this.invoiceForm.email,
      }
      if(this.invoiceForm.billing_object == 1){
        postData.company_name = this.invoiceForm.company_name
        postData.company_tax_id = this.invoiceForm.company_tax_id
        postData.company_address = this.invoiceForm.company_address
        postData.phone_number = this.invoiceForm.phone_number
        postData.bank_name = this.invoiceForm.bank_name
        postData.bank_account = this.invoiceForm.bank_account
      }else{
        postData.name = this.invoiceForm.name
      }
      this.btnDisabled = true
      invoiceAdd(postData).then(res =>{
        if(res.code == 200){
          this.pageNum = 1
          this.getOrderList()
          this.showModal = false
          this.$message.success(res.message)
          this.invoiceInfo = JSON.parse(JSON.stringify(this.$options.data().invoiceInfo))
        }
        this.btnDisabled = false
      })
    },
    copyInviteLink() {
      navigator.clipboard.writeText(this.inviteLink + this.userInfo.recode)
          .then(() => {
            Message.success("The link has been copied to the clipboard");
          })
          .catch(err => {
            Message.error("Copy failed. Please do it manually...");
          });
    }
  },
};
</script>

<style lang="scss" scoped>
.personal_center {
  font-family: Arial, sans-serif;
  color: #333;
  position: relative;

  .personal_center_header {
    width: 100%;
    min-width: 1000px;
    height: 152px;
    background-color: #24272a;
    padding: 50px 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 204px;
      height: 37px;
      cursor: pointer;
    }

    .header_right {
      display: flex;
      gap: 20px;

      button {
        font-size: 24px;
        height: 54px;
        border-radius: 27px;
        padding: 0 36px;
        cursor: pointer;
        border: none;
        // font-weight: bold;
      }

      & button:first-child {
        background-color: #070809;
        color: #fff;

        &:hover {
          background-color: #2a82e4;
        }
      }

      & button:nth-child(2) {
        background-color: #fff;
        color: #000;

        &:hover {
          background-color: #e4e6ef;
        }
      }
    }
  }

  .personal_content {
    width: 70%;
    margin: 20px auto;
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    gap: 40px;

    .personal_content_left {
      flex: 1;
      padding: 0 20px;

      h3 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 30px;
        padding-bottom: 10px;
        text-align: center;
      }

      .info-grid {
        display: flex;
        gap: 40px;
      }

      .info-column {
        flex: 1;
      }

      .info-row {
        margin-bottom: 20px;

        .forgetPsd {
          border: 1px solid #2a82e4;
          background-color: #fff;
          color: #2a82e4;
          width: 100%;
          height: 40px;
          border-radius: 20px;
          // margin-top: 23px;
          cursor: pointer;

          &:hover {
            border: 1px solid #fff;
            background-color: #2a82e4;
            color: #fff;
          }
        }

        label {
          display: block;
          font-size: 14px;
          color: #777;
          margin-bottom: 5px;
        }

        input {
          width: 100%;
          height: 40px;
          border: 1px solid #e4e6ef;
          border-radius: 4px;
          padding: 0 10px;
          background-color: #f9f9f9;
          font-size: 14px;
        }
      }

      .member-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        padding-top: 15px;
        border-top: 1px solid #eee;

        span {
          font-size: 14px;
          color: #333;
        }

        .renew-btn {
          border: none;
          background-color: #2a82e4;
          color: #fff;
          width: 18%;
          height: 40px;
          border-radius: 20px;
          margin-top: 10px;
          cursor: pointer;
          transform: translateY(-4px);

          &:hover {
            border: 1px solid #2a82e4;
            background-color: #fff;
            color: #2a82e4;
          }
        }
      }
    }

    .divider {
      width: 2px;
      background-color: #eee;
    }

    .personal_content_right {
      flex: 1;
      padding: 0 20px;

      h3 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 54px;
        padding-bottom: 10px;
        text-align: center;
      }

      .subscription-options {
        display: flex;
        flex-direction: column;
        gap: 32px;
      }

      .subscription-item {
        border: 1px solid #e4e6ef;
        border-radius: 70px;
        padding: 30px 20px;
        cursor: pointer;
        transition: all 0.3s;
        text-align: center;

        &:hover {
          border-color: #2a82e4;
          background-color: #f5f9ff;
        }

        .price {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 5px;
        }

        .daily-price {
          font-size: 14px;
          color: #2a82e4;
        }
      }
    }
  }

  .free-authorization-btn {
    display: block;
    width: 300px;
    height: 50px;
    margin: 30px auto;
    background-color: #24272a;
    color: #fff;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: background-color 0.3s;

    &:hover {
      background-color: #2a82e4;
    }
  }

  .footer_text {
    text-align: center;
    font-size: 16px;

    .w_80{
      width: 80%;
      margin: 0 auto;
    }

    span {
      color: #2a82e4;
    }

    button {
      border: none;
      font-size: 10px;
      padding: 6px 12px;
      border-radius: 13px;
      margin-left: 6px;
      background-color: #cccccc;
      color: #fff;
      cursor: pointer;
    }

    table {
      width: 70%;
      border-collapse: collapse;
      margin-top: 20px;
      margin: 20px auto;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    tr:hover {
      background-color: #f1f1f1;
    }

    .header {
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  .tableCard {
    padding: 90px 120px 0px 120px;
    :deep {
      .el-table thead {
        color: #000;
      }
      .el-table th.el-table__cell {
        background: #f6f6f8;
      }
      .font12 {
        font-size: 12px;
      }
    }
    .table_pagination{
      text-align: right;
      padding-top: 10px;
    }
  }

  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: rgba(52,53,53,.8);
    border-radius: 10px;
    width: 600px;
    max-width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .modal-header {
    padding: 20px;
    display: flex;
    position: relative;
    h3 {
      margin: 0;
      font-size: 30px;
      font-weight: 400;
      text-align: center;
      color: #fff;
      display: block;
      width: 100%;
    }
    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #fff;
      padding: 0;
      line-height: 1;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      font-family: "思源黑体Medium";
    }
  }

  .modal-body {
    padding: 20px 54px;
    max-height: calc(90vh - 140px);
    overflow: auto;
    p {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;
      color: #fff;
      &::before {
        content: attr(data-label);
        display: inline-block;
        width: 140px;
        padding-right: 10px;
      }

      input,
      select {
        // 同时为input和select设置相同样式
        flex: 1;
        height: 40px;
        border: 1px solid #fff;
        border-radius: 4px;
        padding: 0 10px;
        background-color: #fff;
        font-size: 14px;
        appearance: none; // 移除默认样式
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 12px;
        color: #000;
      }

      select {
        cursor: pointer;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");

        option {
          padding: 8px;
        }
        &:focus-visible{
          outline: none;
        }
      }
    }
  }

  .modal-footer {
    padding: 20px 54px 40px;
    text-align: right;
    .close-btn {
      background-color: #fff;
      border-radius: 20px;
      padding: 10px 30px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;
      border: none;
      margin-right: 12px;
      color: #000;
    }
    .confirm-btn {
      background-color: #2a82e4;
      color: white;
      border: none;
      border-radius: 20px;
      padding: 10px 30px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #1a6bc8;
      }
    }
  }
}
</style>
